import React from "react";
import {
  MixedWidget1,
  MixedWidget14,
  ListsWidget9,
  StatsWidget11,
  StatsWidget12,
  ListsWidget1,
  AdvanceTablesWidget2,
  AdvanceTablesWidget4,
  ListsWidget3,
  ListsWidget4,
  ListsWidget8,
} from "../widgets";
export function CuplooDashboard() {
  return (
    <>
      <div className="row justify-content-center">
        <div className="col-lg-10 col-xxl-10">
          <MixedWidget1 className="card-stretch gutter-b" />
        </div>
        
      </div>
    </>
  );
}
